import { COLOR_PALETTE } from './ui';

export const StatusEnum = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  IN_PROGRESS: 'inProgress',
};

export const StatusColor = {
  [StatusEnum.SUCCESS]: COLOR_PALETTE.GREEN[2],
  [StatusEnum.WARNING]: COLOR_PALETTE.ORANGE[2],
  [StatusEnum.ERROR]: COLOR_PALETTE.RED[2],
  [StatusEnum.INFO]: COLOR_PALETTE.BLUE[2],
};

export const CicReasonStatusEnum = {
  PENDING: 'Pending',
  DISCLOSED: 'Disclosed',
  SAVED: 'Saved',
  DELETED: 'Deleted',
};
